import AboutImg from '../../../assets/image/profile/about.jpg';
const AboutContent = () => {
  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center my-4 px-3 text-justify">
        <img src={AboutImg} alt="درباره ما" className="img-fluid w-75" />
        <p className="lh-lg mt-4 text-break color-gray-1">
          ماموریت ما ساختن نرم افزاری است که آینده بهتری را برای کسب و کار شما
          ایجاد کند
        </p>
        <p className="lh-lg text-break color-gray-1">
          اکنون هزاران کشاورز با اپلیکیشن مزرعه کار می‌کنند و شما می‌توانید در
          سامانه مزرعه با آن‌ها در تعامل باشید. در مزرعه، ما تلاش می‌کنیم تا
          ارتباط بیشتری در زنجیره تامین کشاورزی از مزرعه تا سفره ایجاد کنیم. چون
          معتقدیم هر اتفاقی که بیافتد، این فعالان کشاورزی هستند که باید غذای
          مردم را فراهم کنند. ما در تلاش هستیم هر روز نوآوری بیشتری در مزرعه
          ایجاد کنیم و مشتاقانه منتظر کار با شما هستیم.
        </p>
        <p className="lh-lg text-break color-gray-1">
          زمانی که فناوری اطلاعات به کمک کسب و کارهای مختلف آمد، تحولی در کسب و
          کارهای کشاورزی ایران ایجاد نشد. متوجه شدیم مشکل اصلی فعالان این حوزه
          نداشن اطلاعات ضروری برای مدیریت بهتر کسب و کارشان هست. داستان مزرعه
          سال 1398 با چند کشاورز و مهندس برای ایجاد تغییر شروع شد. مزرعه طی چند
          سال شروع به ساخت نرم افزار ساده‌ای کرد که به کشاورزان برای مدیریت بهتر
          فعالیت‌ها کمک می‌کند و آن‌ها را به تامین‌کنندگان و مشتریان محصولات‌شان
          مرتبط می‌سازد.
        </p>
      </div>
    </>
  );
};

export default AboutContent;
